import { type Callback } from './types/propsType';

class EventEmitter {
  private events: { [eventName: string]: Callback[] };
  private isBlockRoute: boolean;
  private isBackBlocked: boolean;

  constructor() {
    this.events = {};
    this.isBlockRoute = false;
    this.isBackBlocked = false;
  }

  on(eventName: string, callback: Callback): void {
    if (!this.events[eventName]) {
      this.events[eventName] = [];
    }
    this.events[eventName].push(callback);
  }

  off(eventName: string, callback: Callback): void {
    const eventCallbacks = this.events[eventName];
    if (!eventCallbacks) {
      return;
    }
    const index = eventCallbacks.indexOf(callback);
    if (index !== -1) {
      eventCallbacks.splice(index, 1);
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  emit(eventName: string, ...args: any[]): void {
    const eventCallbacks = this.events[eventName];
    if (!eventCallbacks) {
      return;
    }
    eventCallbacks.forEach((callback) => {
      callback(...args);
    });
  }

  setIsBlockRoute(value: boolean): void {
    this.isBlockRoute = value;
  }

  getIsBlockRoute(): boolean {
    return this.isBlockRoute;
  }

  setIsBackBlocked(value: boolean): void {
    this.isBackBlocked = value;
  }

  getIsBackBlocked(): boolean {
    return this.isBackBlocked;
  }
}

export const events = new EventEmitter();
